<fcom-generic-icon [name]="iconId" [url]="svgPath"></fcom-generic-icon>
<span *ngIf="informative" class="is-vishidden">{{ 'icons.' + mappedName | finLocalization }}</span>
